export const csmAiTokens = {
	'color.100': '--csm-color-100',
	'color.200': '--csm-color-200',
	'color.300': '--csm-color-300',
	'color.400': '--csm-color-400',
	'color.500': '--csm-color-500',
	'color.600': '--csm-color-600',
	'color.700': '--csm-color-700',
	'color.800': '--csm-color-800',
	'color.900': '--csm-color-900',
	'color.1000': '--csm-color-1000',
	'color.icon': '--csm-color-icon',
	'color.brand': '--csm-color-brand',
	'color.brand.hover': '--csm-color-brand-hover',
	'color.brand.active': '--csm-color-brand-active',
	'color.brand.text': '--csm-color-brand-text',
	'color.brand.hover.text': '--csm-color-brand-hover-text',
	'color.brand.active.text': '--csm-color-brand-active-text',
	'border.radius.lg': '--csm-border-radius-lg',
	'border.radius.md': '--csm-border-radius-md',
	'border.radius.sm': '--csm-border-radius-sm',
	'border.radius.container': '--csm-border-radius-container',
	'border.radius.widget': '--csm-border-radius-widget',
	'space.lg': '--csm-space-lg',
	'space.md': '--csm-space-md',
	'space.sm': '--csm-space-sm',
} as const;
